import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupComponent } from './signup/signup.component';
import { SharedModule } from "../shared/shared.module";
import { MaterialModule } from "../shared/material.module";
import { StatusTrackerModule } from "../status-tracker/status-tracker.module";
import { TellUsAboutYourselfComponent } from "./tell-us-about-yourself/tell-us-about-yourself.component";
import { EmploymentDetailsComponent } from "./employment-details/employment-details.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { BsaProfileComponent } from './bsa-profile/bsa-profile.component';
import {CoreModule} from "../core/core.module";
import { ValidationComponent } from './validation/validation.component';
import { SuggestedAddressComponent } from './suggested-address/suggested-address.component';
import { NgxMaskModule } from "ngx-mask";
import { CodeVerificationComponent } from './code-verification/code-verification.component';
import { ApplicantsComponent } from "./applicants/applicants.component";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import {PromoCodeComponent} from "./promo-code/promo-code.component";
import { AccountSelectorComponent } from './account-selector/account-selector.component';
import { AccountSelectionComponent } from './account-selection/account-selection.component';
import { SelectAccountsComponent } from './select-accounts/select-accounts.component';
import { AccountOwnershipComponent } from './account-ownership/account-ownership.component';

@NgModule({
  declarations: [
    SignupComponent,
    ApplicantsComponent,
    TellUsAboutYourselfComponent,
    EmploymentDetailsComponent,
    BsaProfileComponent,
    ValidationComponent,
    SuggestedAddressComponent,
    CodeVerificationComponent,
    PromoCodeComponent,
    AccountSelectorComponent,
    AccountSelectionComponent,
    SelectAccountsComponent,
    AccountOwnershipComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StatusTrackerModule,
    FlexLayoutModule,
    CoreModule,
    NgxMaskModule.forChild(),
    GooglePlaceModule,
  ],
    exports: [
        SignupComponent,
        TellUsAboutYourselfComponent,
        EmploymentDetailsComponent,
        BsaProfileComponent,
        ApplicantsComponent,
        AccountSelectorComponent,
        AccountSelectionComponent,
        SelectAccountsComponent,
        PromoCodeComponent,
        AccountOwnershipComponent
    ]
})
export class SignupModule {
}
